import React from 'react';
import { Granit } from 'src/services/granits';
import { isTwoSteleEqual } from 'src/utils/3d.utils';
import { GranitCard } from './GranitCard';

type GranitGridProps = {
  sortedGranits: Granit[];
  type: string;
  piece: any;
  stockData: { granitId: string }[] | undefined;
  stockStelesData: { stele: any; granitId: string }[] | undefined;
  seeAssemblyStock: boolean;
  currentSelectedTexture: { name: string } | undefined;
  bucketUrl: string;
  onChangeGranit: (granit: Granit) => void;
};

const EmptyState = () => (
  <div className='flex flex-col items-center justify-center h-48 text-gray-400'>
    <svg
      className='w-12 h-12 mb-3'
      fill='none'
      stroke='currentColor'
      viewBox='0 0 24 24'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
      />
    </svg>
    <p className='text-sm font-medium'>Aucun granit disponible</p>
    <p className='text-xs mt-1'>Essayez de modifier vos filtres</p>
  </div>
);

const useHasStock = (
  granit: Granit,
  type: string,
  piece: any,
  stockData: GranitGridProps['stockData'],
  stockStelesData: GranitGridProps['stockStelesData'],
  seeAssemblyStock: boolean,
) => {
  if (seeAssemblyStock) return true;

  if (type === 'customStele') {
    return !!stockStelesData?.find(
      (stock) =>
        isTwoSteleEqual(stock.stele, piece) && stock.granitId === granit.id,
    );
  }

  return !!stockData?.find((stock) => stock.granitId === granit.id);
};

export const GranitGrid = ({
  sortedGranits,
  type,
  piece,
  stockData,
  stockStelesData,
  seeAssemblyStock,
  currentSelectedTexture,
  bucketUrl,
  onChangeGranit,
}: GranitGridProps) => {
  if (sortedGranits.length === 0) {
    return <EmptyState />;
  }

  return (
    <div className='grid grid-cols-2 lg:grid-cols-3 gap-4'>
      {sortedGranits.map((granit, index) => {
        const hasStock = useHasStock(
          granit,
          type,
          piece,
          stockData,
          stockStelesData,
          seeAssemblyStock,
        );

        return (
          <div key={index} className='items-center justify-center flex'>
            <GranitCard
              granit={granit}
              imageUrl={`${bucketUrl}/${granit.image}`}
              isSelected={currentSelectedTexture?.name === granit.name}
              hasStock={hasStock}
              onClick={() => onChangeGranit(granit)}
            />
          </div>
        );
      })}
    </div>
  );
};
